module.exports = __webpack_public_path__ + "img/slack_icon_white.f98a41dc.png";